/**
*
* Licensed under the MIT license.
* http://www.opensource.org/licenses/mit-license.php
* 
* Copyright 2019, Codrops
* http://www.codrops.com
*
* Modified By LiquidThemes
*/
(function ( $ ) {
	
	'use strict';
	
	const pluginName = 'liquidDistortedImageGallery';
	let defaults = {
		imagesContainerSelector: '.lqd-dist-gal-distort',
		menuSelector: '.lqd-dist-gal-menu',
		menuItemSelector: '.lqd-dist-gal-menu-item',
		svgSelector: '.lqd-dist-gal-distort'
	};

	class Plugin {
		
		constructor(element, options) {
			
			this.element = element;
			this.$element = $(element);
			
			this.options = $.extend({}, defaults, options);
			
			this._defaults = defaults;
			this._name = pluginName;

			this.DOM = {
				imagesContainer: this.element.querySelector(this.options.imagesContainerSelector),
				svg: this.element.querySelector(this.options.svgSelector),
				menu: this.element.querySelector(this.options.menuSelector),
				feDisplacementMapEl: this.element.querySelector('feDisplacementMap'),
				feBlurEl: this.element.querySelector('feGaussianBlur'),
				feTurbulence: this.element.querySelector('feTurbulence')
			};
			// The images (one per menu link)
			this.DOM.imgs = [...this.DOM.imagesContainer.querySelectorAll('.lqd-dist-gal-img')];
			// The menu links
			this.DOM.menuLinks = [...this.DOM.menu.querySelectorAll(this.options.menuItemSelector)];
			// Mouse position
			this.mousePos = {x: liquidWindowWidth()/2, y: liquidWindowHeight()/2};
			// Last mouse positions (one to consider for the image translation movement, another for the scale value of the feDisplacementMap element)
			this.lastMousePos = {
				translation: {x: liquidWindowWidth()/2, y: liquidWindowHeight()/2},
				displacement: {x: 0, y: 0}
			};
			// feDisplacementMap scale value
			this.dmScale = 0;
			this.brightness = 0;
			this.rotate = 0;
			// Current menu link position
			this.current = -1;

			this.rAFId = null;
			
			this.elOffsetTop = this.$element.offset().top;
			
			this.initEvents();

		}

		lerp(a, b, n) {
			return ( (1 - n) * a + n * b )
		}

		distance(x1,x2,y1,y2) {
			var a = x1 - x2;
			var b = y1 - y2;
			return Math.hypot(a,b);
		}

		lineEq(y2, y1, x2, x1, currentVal){
			var m = (y2 - y1) / (x2 - x1), b = y1 - m * x1;
			return m * currentVal + b;
		}

		initEvents() {

			const isMobile = liquidIsMobile();

			if ( ! isMobile ) {
				window.addEventListener('mousemove', ev => this.mousePos = liquidGetMousePos(ev));
			}
			
			this.DOM.menuLinks.forEach((item, pos) => {

				if ( ! isMobile ) {
					const mouseenterFn = () => {
	
						if ( this.current !== -1 ) {
							gsap.to(this.DOM.imgs[this.current], {
								duration: 0.2,
								opacity: 0,
								ease: 'power2.out'
							});
						}
	
						this.current = pos;
	
						if ( this.fade ) {
							gsap.to(this.DOM.imgs[this.current], {
								duration: 0.2,
								opacity: 1,
								ease: 'power2.out'
							});
							this.fade = false;
						} else {
							gsap.to(this.DOM.imgs[this.current], {
								duration: 0.2,
								opacity: 1,
								ease: 'power2.out'
							});
						}
	
						
					};
	
					const mouseleaveFn = () => {
						gsap.to(this.DOM.imgs[this.current], {
							duration: 0.2,
							opacity: 0,
							ease: 'power2.out'
						});
					}
					
					item.addEventListener('mouseenter', mouseenterFn);
					item.addEventListener('mouseleave', mouseleaveFn);
				} else {
					item.addEventListener('click', ev => {
						ev.preventDefault();
						const imagesWrapper = this.DOM.imgs[pos];
						const links = [...imagesWrapper.querySelectorAll('a.fresco')];
						if ( links.length > 0 ) {
							links[0].click();
						}
					})
				}
				


			});

			if ( ! isMobile ) {
				this.DOM.menu.addEventListener('mouseenter', () => {
					this.rAFId = requestAnimationFrame(this.render.bind(this));
					this.fade = true;
				});
	
				this.DOM.menu.addEventListener('mouseleave', () => {
					this.rAFId && cancelAnimationFrame(this.rAFId);
				});
			}


		}

		render() {

			// Translate the image on mousemove
			const mouseDistance = this.distance(this.lastMousePos.displacement.x, this.mousePos.x, this.lastMousePos.displacement.y, this.mousePos.y);

			this.lastMousePos.translation.x = this.lerp(this.lastMousePos.translation.x, this.mousePos.x, 0.2);
			this.lastMousePos.translation.y = this.lerp(this.lastMousePos.translation.y, this.mousePos.y, 0.2);
			this.lastMousePos.displacement.x = this.lerp(this.lastMousePos.displacement.x, this.mousePos.x, 0.1);
			this.lastMousePos.displacement.y = this.lerp(this.lastMousePos.displacement.y, this.mousePos.y, 0.1);

			
			// this.dmScale = Math.min(this.lineEq(50, 1, 140, 1, mouseDistance), 50);
			this.brightness = Math.min(this.lineEq(1.75, 1, 140, 1, mouseDistance), 1.5);
			this.contrast = Math.min(this.lineEq(1.1, 1, 140, 1, mouseDistance), 1.5);
			
			if ( this.lastMousePos.translation.x > this.mousePos.x ) {
				this.rotate = Math.min(this.lineEq(-7, 0, 130, 0, mouseDistance), 50);
			} else {
				this.rotate = Math.min(this.lineEq(7, 0, 130, 0, mouseDistance), 50);
			}

			gsap.to(this.DOM.imagesContainer, {
				x: this.lastMousePos.translation.x-liquidWindowWidth()/2,
				y: this.lastMousePos.translation.y - this.elOffsetTop,
				rotation: this.rotate,
				// filter: `brightness(${this.brightness}) contrast(${this.contrast})`
			});
			
			// this.DOM.feDisplacementMapEl.scale.baseVal = this.dmScale * 1.15;
			
			this.rAFId = requestAnimationFrame(this.render.bind(this));

		}
		
	}
	
	$.fn[ pluginName ] = function( options ) {
		
		return this.each( function() {
			
			const pluginOptions = {...$(this).data('dist-gal-options'), ...options};
			
			if ( !$.data( this, "plugin_" + pluginName ) ) {
				$.data( this, "plugin_" + pluginName, new Plugin( this, pluginOptions ) );
			}
			
		} );
		
	};
	
}(jQuery));

jQuery(document).ready( function($) {
  $('[data-lqd-dist-gal]').liquidDistortedImageGallery();
});